import React from 'react'
import { Tooltip } from '@material-ui/core'
import BiotechIcon from '@material-ui/icons/Biotech'
import ResultButton from './ResultButton'

/**
 * Variants-table entry point for a somatic (tumour) analysis.
 *
 * Deliberately not a prop on AnalysisPopover. That component resolves its URL
 * from `useSampleMetadata` -> `tables[0].id`, a germline concept the somatic
 * parquet has no equivalent of; hooks cannot be skipped conditionally, so
 * reusing it would fire a metadata request per somatic row and then gate the
 * button on a table id that never arrives, leaving the button permanently
 * hidden.
 *
 * Keyed on the analysis wrapper rather than (fileId, sampleName): a tumour
 * analysis can carry a tumour and a normal, so there is no single "the VCF
 * file" to name it by.
 */
const GoToSomaticVariants = ({ analysisWrapperId }) => {
  const url = `/libra/somatic-variants/${analysisWrapperId}`

  const handleClick = (e) => {
    // Left click only, so middle-click still opens a new tab.
    if (e.button === 0) {
      e.preventDefault()
      window.location.href = url
    }
  }

  const handleContextMenu = (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(window.location.origin + url)
  }

  return (
    <Tooltip title="Somatic SNV/Indel table" arrow>
      <ResultButton
        primary
        tone="somatic"
        startIcon={<BiotechIcon />}
        href={url}
        onClick={handleClick}
        onContextMenu={handleContextMenu}
      >
        Somatic SNV/Indel
      </ResultButton>
    </Tooltip>
  )
}

export default GoToSomaticVariants
